<template>
    <div class="limit-size" @click.stop>
        <div class="size" @click="show">
            <img src="@/assets/img/box.svg">
            <span>限制 40x25x30 cm</span>
        </div>
        <div class="alert" v-if="isShow" @click="close">
            <div class="content" @click.stop>
                <div class="title">體積限制</div>
                <div class="subtitle">若您購買/運送的物品過大，請備註讓我們知道：）</div>
                <img src="@/assets/img/limit-size.png">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'limitSize',
        data() {
            return {
                isShow: false,
            }
        },
        methods: {
            show() {
                this.isShow = true;
            },
            close() {
                this.isShow = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .limit-size {
        .size {
            font-size: 12px;
            color: #9B9B9B;
            display: flex;
            align-items: center;
            cursor: pointer;

            span {
                margin-left: 5px;
            }
        }

        .alert {
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,.4);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 9;
            display: flex;
            justify-content: center;
            align-content: center;

            .content {
                background-color: #fff;
                width: fit-content;
                height: fit-content;
                margin: auto;
                text-align: left;
                padding: 15px;
                border-radius: 6px;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);

                .title {
                    font-size: 16px;
                    color: #4A4A4A;
                    font-weight: 600;
                }

                .subtitle {
                    font-size: 12px;
                    color: #4A4A4A;
                    margin-top: 5px;
                }

                img {
                    margin-top: 25px;
                    width: 345px;
                    max-width: 100%;
                    height: auto;
                }
            }
        }
    }
</style>
